<template>
  <v-row>
    <v-col 
      cols="12"
      v-if="type_of_activity_id==3||type_of_activity_id==4">
      <v-sheet
        v-if="!activity.link_youtube"
        outlined
        color="error">
        <p class="mt-4 mb-4 white--text d-flex justify-center align-center">
          ¡PRECAUCÍON! Ésta actividad fue establecida como HÍBRIDA ó VIRTUAL, pero 
          todavía no fue configurada la URL de la transmisíon.
        </p>
      </v-sheet>
    </v-col>

    <v-col cols="12">
      <v-sheet
        v-if="type_of_activity_id==3||type_of_activity_id==4"
        outlined>

        <v-row>
          <v-col cols="12">
            <v-img
              :src="url_banner_auditorium"
              fill
              class="image-banner"/>
          </v-col>
        </v-row>

        <v-row class="pa-4">
          <v-col cols="12">
            
            <v-row style="height: 400px;">
              <v-col 
                cols="12" 
                xl="8" 
                md="8" 
                sm="12" 
                style="display: flex;">

                  <LazyYoutube 
                    autoplay 
                    class="ma-0 video"
                    :src="activity.link_youtube" 
                    v-if="!activity.link_youtube" 
                  />

                  <h2
                    v-if="!activity.link_youtube" 
                    class="ma-0 video d-flex justify-center align-center">
                    VIDEO
                  </h2>
              </v-col>

              <v-col
                v-if="$vuetify.breakpoint.smAndUp" 
                cols="12" 
                xl="4" 
                md="4" 
                sm="12" 
                class="section-chat mt-3 mb-3 d-flex justify-center align-center" 
                style="display: flex;">
                <h2>
                  CHAT
                </h2>
              </v-col>
            </v-row>

            <v-row v-if="!$vuetify.breakpoint.smAndUp">
              <v-col cols="12">
                <v-btn
                  block
                  @click="show_chat=true"
                  color="primary">
                  CHAT
                </v-btn>
              </v-col>
              <v-divider></v-divider>
            </v-row>
            
            <v-row v-if="$vuetify.breakpoint.smAndUp" style="padding-top: 20px;">
              <v-divider></v-divider>
            </v-row>

            <v-row>
              <v-col cols="12">
                <h3>{{ activity.name }}</h3>
                <label for="place">{{ activity.place }}</label>
                <p class="text--secondary">{{ activity.description }}</p>
                
                <label v-show="activity.target_audience" for="target_audience font-weight-bold">Público objetivo:</label>
                <p class="text--secondary">{{ activity.target_audience }}</p>

              </v-col>

              <v-col cols="12">
                <h3>Moderador/es:</h3>
                <h4
                  v-for="moderator in activity.moderators" :key="moderator.id"
                  class="text--secondary mt-2 ml-8">
                  <v-icon class="mb-1">
                    mdi-bullhorn-variant-outline
                  </v-icon>
                  {{ moderator.name }}
                </h4>
                
                <label v-show="activity.target_audience" for="target_audience font-weight-bold">Público objetivo:</label>
                <p class="text--secondary">{{ activity.target_audience }}</p>

              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-col>
      <v-sheet>
        <v-row class="pa-4">
          <v-col>
            <v-row>
              <v-col cols="12" xl="6" md="6" sm="12">
                <h3>
                  Tipo de actividad:
                </h3>
                
                <p class="font-weight-light">
                  {{ activity.type_of_activity.name  }}
                </p>
              </v-col>

              <v-col cols="12" v-if="activity.target_audience">
                <p class="font-weight-regular text-uppercase">
                  Público objetivo:
                </p>
                
                <p class="font-weight-light">
                  {{ activity.target_audience  }}
                </p>
              </v-col>

              <v-col cols="12" xl="6" md="6" sm="12">
                <h3>
                  Fecha:
                </h3>
                
                <p class="font-weight-light">
                  {{ convertDate(activity.program.date)  }}
                </p>
              </v-col>

              <v-col cols="12" v-if="activity.all_day">
                <h3>
                  Horario:
                </h3>
                
                <p class="font-weight-light">
                  La actividad dura todo el día
                </p>
              </v-col>

              <v-col cols="12" xl="6" md="6" sm="12" v-if="!activity.all_day">
                <h3>
                  Horario de inicio:
                </h3>
                
                <p class="font-weight-light">
                  {{ activity.start_time  }} hs.
                </p>
              </v-col>

              <v-col cols="12" xl="6" md="6" sm="12" v-if="!activity.all_day">
                <h3>
                  Horario de fín:
                </h3>
                
                <p class="font-weight-light">
                  {{ (activity.finish_time)?activity.finish_time+' hs.':'--' }}
                </p>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>


    <v-col cols="12" class="pt-2 d-flex justify-space-between">
      <v-btn
        depressed
        color="primary"
        :to="{ name: 'activitiesProgramEdition', params: { edition_id:this.edition_id, program_id:this.program_id }}"
        >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>
    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300">
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Cargando...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
  import axios from 'axios'
  import { LazyYoutube } from "vue-lazytube"
  const APP_URL = process.env.VUE_APP_URL

  export default {
    name: 'showActivityProgramEdition',
    components: {
        LazyYoutube 
    },
    data: () => ({
      loading:true,
      loading_btn: false,
      loading_update:false,

      edition_id:null,
      program_id:null,
      activity_id: null,

      activity:[],

      name:null,
      description:null,
      place: null,
      all_day:true,
      start_time:null,
      finish_time: null,
      target_audience: null,

      miniature:null,
      url_miniature:null,

      type_of_activities:[],
      type_of_activity_id: null,

      url_banner_auditorium:null,
      link_youtube:null,
    }),

    methods:{
      async getTypeOfActivities()
      {
        await axios.get('type-of-activities').then(response =>{
          this.type_of_activities = response.data.data.type_of_activities
          this.loading=false
        }).catch(error => {
          console.log(error);
        })
      },

      convertDate(date) {
        const parts = date.split('-');
        const day = parts[2];
        const month = parts[1];
        const year = parts[0];

        return `${day}/${month}/${year}`;
      },

      async getActivityEdition(){
        await axios.get('admin/editions/'+this.edition_id+'/program-edition/'+this.program_id+'/activities/'+this.activity_id).then(response =>{
          this.activity = response.data.data.activity

          this.name = this.activity.name
          this.description = this.activity.description
          this.place = this.activity.place
          this.all_day = (this.activity.all_day==1)?true:false
          
          this.start_time = this.activity.start_time
          this.finish_time = this.activity.finish_time
          this.target_audience = this.activity.target_audience
          this.miniature = this.activity.miniature
          this.url_miniature = this.activity.url_miniature
          this.type_of_activity_id = this.activity.type_of_activity_id

          if(this.activity.auditorium!=null){
            this.url_banner_auditorium = APP_URL+ this.activity.auditorium.banner
          }

          this.loading=false
        }).catch(error => {
          console.log(error);
        })
      }
    },
    created(){
      this.edition_id = this.$route.params.edition_id
      this.program_id = this.$route.params.program_id
      this.activity_id = this.$route.params.activity_id
      this.getActivityEdition()
    },
  }
</script>
<style scoped>
.image-banner{
	position: relative;
  height: 120px;
	width: 100%;
  border-bottom: 5px solid #00a1b8;
}
.content-video{
  background-color: rgb(0, 0, 0);
  text-align: center;
  border-bottom: 5px solid #00a1b8;
  position: relative;
  height: 380px;
}

.video{
  width: 100%;
  z-index: 0;
  border: 2px solid #00a1b8;
  border-radius: 4px;
}

.section-chat{
  background-size: cover;
  max-height: max-content;
  border-radius: 4px;
  border: 2px solid #00a1b8;
}
</style>
